// src/perametric/tabs/PatternTabs.jsx
import React, { useState } from "react";
import LibraryTab from "./tabs/LibraryTab";

const PatternTabs = ({ topCellName, aiLaunchRequestId = 0 }) => {
  const [activeTab, setActiveTab] = useState("library");

  const renderContent = () => {
    switch (activeTab) {
      case "library":
        return (
          <LibraryTab
            topCellName={topCellName}
            aiLaunchRequestId={aiLaunchRequestId}
          />
        );
      case "import":
        return (
          <div style={{ color: "#ccc", padding: "10px" }}>
            📁 Import panel coming soon
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div style={tabRowStyle}>
        <button onClick={() => setActiveTab("library")} style={btn(activeTab === "library")}>Library</button>
        <button onClick={() => setActiveTab("import")} style={btn(activeTab === "import")}>Import</button>
      </div>
      <div>{renderContent()}</div>
    </div>
  );
};

const tabRowStyle = {
  display: "flex",
  gap: "15px",
  marginBottom: "10px",
};

const btn = (active) => ({
  padding: "4px 12px",
  backgroundColor: active ? "#00bcd4" : "#2d2d2d",
  color: "#fff",
  border: "1px solid #444",
  borderRadius: "4px",
  cursor: "pointer",
});

export default PatternTabs;
